/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

import Tooltip from './Tooltip';
import { IUncontrolledTooltipProps } from './Tooltip.props';

export interface IUncontrolledTooltipState {
    isOpen: boolean;
}

/**
 * UncontrolledTooltip examples.
 */
export default class UncontrolledTooltip extends React.Component<IUncontrolledTooltipProps, IUncontrolledTooltipState> {
    constructor(props: IUncontrolledTooltipProps) {
        super(props);
        this.state = { isOpen: false };
        this._toggle = this._toggle.bind(this);
    }

    public render(): JSX.Element {
        return <Tooltip isOpen={this.state.isOpen} toggle={this._toggle} {...this.props} />;
    }

    private _toggle(): void {
        this.setState({ isOpen: !this.state.isOpen });
    }
}
